import { authenticationViewReducer as authenticationView } from 'modules/authentication/slices/authentication-view.slice'
import { userEntitiesReducer as userEntities } from 'modules/authentication/slices/user-entities.slice'
import { creditBalanceReducer as creditBalance } from 'modules/billing/slices/credit-balance.slice'
import { revenueCatReducer as revenueCat } from 'modules/billing/slices/revenue-cat.slice'
import { userLimitationsReducer as userLimitations } from 'modules/billing/slices/user-limitations.slice'
import { businessEntitiesReducer as businessEntities } from 'modules/business'
import { baseApi } from 'modules/core/services/api/base-api'
import { onboardingViewReducer as onboardingView } from 'modules/onboarding'
import { combineReducers } from 'redux'

const rootReducer = combineReducers({
  // API
  [baseApi.reducerPath]: baseApi.reducer,

  // Entities
  businessEntities,
  userEntities,

  // Billing
  creditBalance,
  revenueCat,
  userLimitations,

  //Views
  authenticationView,

  // Onboarding
  onboardingView,
})

export default rootReducer
